import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { useSelector } from "react-redux";
// @mui
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { Edit } from "@mui/icons-material";
import CustomTable from "../components/data-table/CustomDataTable";
import OfferForm from "../sections/@dashboard/offer/offer.form";

import {
  useGetOffersQuery,
  useDeleteOfferMutation,
} from "../redux/services/offer.service";
// components
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
// sections
import Protected from "../protected/Protected";
import { selectAbility } from "../redux/slices/casl.slice";
import CustomDeleteConfirmation from "../components/dialog/CustomDeleteConfirmation";

export default function OfferPage() {
  const ability = useSelector(selectAbility);

  const [openOfferForm, setOpenOfferForm] = useState(false);

  const [edit, setEdit] = useState(false);

  const [openRow, setOpenRow] = useState(null);

  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);

  const [deleteOffer, { isLoading: isDeleting }] = useDeleteOfferMutation();

  const handleCloseForm = () => {
    setOpenOfferForm(false);
    setEdit(false);
    setOpenRow(null);
  };

  return (
    <Protected>
      <Helmet>
        <title> Offers </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Offers
          </Typography>
          {ability.can("post", "Offer") && (
            <Button
              variant="contained"
              onClick={() => setOpenOfferForm(true)}
              startIcon={<Iconify icon="eva:plus-fill" />}
            >
              New Offer
            </Button>
          )}
          {(ability.can("post", "Offer") || ability.can("patch", "Offer")) && (
            <OfferForm
              open={openOfferForm}
              onClose={handleCloseForm}
              edit={edit}
              openRow={openRow}
            />
          )}
        </Stack>

        <Card>
          <Scrollbar>
            <CustomTable
              canSelect
              useDataQuery={useGetOffersQuery}
              tableName="Offers"
              searchLabel="Search Offer..."
              searchCols={["name"]}
              actions={
                ability.can("patch", "Offer") || ability.can("delete", "Offer")
                  ? {
                      field: "actions",
                      headerName: "Actions",
                      type: "actions",
                      getActions: ({ row }) =>
                        [
                          ability.can("patch", "Offer") ? (
                            <GridActionsCellItem
                              key="edit"
                              icon={<Edit />}
                              label="Edit"
                              showInMenu
                              onClick={() => {
                                setOpenRow(row);
                                setEdit(true);
                                setOpenOfferForm(true);
                              }}
                            />
                          ) : null,
                          ability.can("delete", "Offer") ? (
                            <GridActionsCellItem
                              key="delete"
                              label="Delete"
                              sx={{
                                color: "error.main",
                              }}
                              icon={
                                <Iconify
                                  color="error.main"
                                  icon="eva:trash-2-outline"
                                />
                              }
                              showInMenu
                              onClick={() => {
                                setOpenDeleteConfirmation(true);
                                setOpenRow(row);
                              }}
                            />
                          ) : null,
                        ].filter((action) => action !== null),
                    }
                  : null
              }
            />
          </Scrollbar>
        </Card>
      </Container>

      {ability.can("delete", "Offer") && (
        <CustomDeleteConfirmation
          open={openDeleteConfirmation}
          onClose={() => setOpenDeleteConfirmation(false)}
          tableName="Offer"
          nameKey={"code"}
          deleteFunc={deleteOffer}
          row={openRow}
          isLoading={isDeleting}
        />
      )}
    </Protected>
  );
}
